import { create } from 'zustand';
import { DiscoveredNpcDTO, IItemInstanceDTO, PlaceDTO } from '@hexcrawl/shared-utils';
import { discoveryService } from '../services/discoveryService';

interface DiscoveryStoreState {
  npcs: DiscoveredNpcDTO[];
  items: IItemInstanceDTO[];
  places: PlaceDTO[];
  loading: boolean;
  pendingLoreId: string | null;
  fetchDiscoveries: (gameId: string) => Promise<void>;
  openLoreAtId: (id: string) => void;
  clearPendingLoreId: () => void;
  clear: () => void;
}

export const useDiscoveryStore = create<DiscoveryStoreState>()((set) => ({
  npcs: [],
  items: [],
  places: [],
  loading: false,
  pendingLoreId: null,

  fetchDiscoveries: async (gameId: string) => {
    set({ loading: true });
    try {
      const result = await discoveryService.fetchDiscoveries(gameId);
      set({ npcs: result.npcs, items: result.items, places: result.places });
    } catch (err) {
      console.error('[DiscoveryStore] Failed to fetch discoveries:', err);
    } finally {
      set({ loading: false });
    }
  },

  openLoreAtId: (id: string) => set({ pendingLoreId: id }),
  clearPendingLoreId: () => set({ pendingLoreId: null }),
  clear: () => set({ npcs: [], items: [], places: [], loading: false, pendingLoreId: null }),
}));
